// extracted by mini-css-extract-plugin
module.exports = {"FinishedTest":"FinishedTest__FinishedTest--5o-rM","success":"FinishedTest__success--3Hzel","error":"FinishedTest__error--2qX6f"};